export const isDependencyPath = (p: string) => /^(\w|@\w|@-)/.test(p);
